// extracted by mini-css-extract-plugin
module.exports = {"knowMore":"OurBrand_knowMore__icgkI"};